export default "__VITE_PUBLIC_ASSET__7ffbb9e4__"